import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'
import { useQuery } from '@tanstack/react-query'
import KNCallToAction from 'components/KNCallToAction/KNCallToAction'
import KNLoader from 'components/KNLoader/KNLoader'
import useDialog from 'global/hooks/useDialog'
import { type ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { equipmentQueryOptions } from './CarrierProfile.service'
import CreateOrEditEquipmentDialog from './CreateOrEditEquipmentDialog'
import EquipmentTable from './EquipmentTable'

const EquipmentTab = (): ReactElement => {
  const { t } = useTranslation()
  const equipmentQuery = useQuery(equipmentQueryOptions)
  const equipment = equipmentQuery.data ?? []
  const createEquipmentDialog = useDialog<typeof CreateOrEditEquipmentDialog>()

  if (equipmentQuery.isPending) {
    return (
      <KNLoader />
    )
  }

  return (
    <>
      {equipment.length > 0 ? (
        <>
          <Stack direction="row" spacing={1} mb={1}>
            <Button
              onClick={createEquipmentDialog.handleOpen}
              variant="contained"
              color="secondary"
              size="small"
              sx={{
                alignSelf: 'start',
              }}
            >
              {t('screens.cs.carrier_profile.equipment.add_equipment')}
            </Button>
          </Stack>
          <EquipmentTable equipment={equipment} />
        </>
      ) : (
        <KNCallToAction
          header={t('screens.cs.carrier_profile.equipment.empty_header')}
          content={t('screens.cs.carrier_profile.equipment.empty_content')}
          sx={{ minHeight: '20rem' }}
        >
          <Button
            variant="contained"
            color="secondary"
            onClick={createEquipmentDialog.handleOpen}
          >
            {t('screens.cs.carrier_profile.equipment.add_equipment')}
          </Button>
        </KNCallToAction>
      )}
      <CreateOrEditEquipmentDialog
        open={createEquipmentDialog.isOpen}
        onAction={createEquipmentDialog.handleAction}
        onClose={createEquipmentDialog.handleClose}
      />
    </>
  )
}

export default EquipmentTab
